import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import OrderTableHead from 'pages/orders/table/Head';
import Body from 'pages/orders/table/Body';

const useStyles = makeStyles({
  container: {
    margin: '30px 0',
    boxShadow: '4px 4px 10px #d9d9d9, -4px -4px 10px #fff',
    borderRadius: '10px',
  },
});

const OrderTable = ({
  orders = [],
  onOrderSelect,
  category,
  voidOrder,
  copyOrder,
  toggleOrderForPayment,
  getShopifyOrder,
}) => {
  const classes = useStyles();

  return (
    <TableContainer className={classes.container} component={Paper}>
      <Table stickyHeader>
        <OrderTableHead
          category={category}
          toggleOrderForPayment={toggleOrderForPayment}
        />
        <TableBody>
          <Body
            getShopifyOrder={getShopifyOrder}
            orders={orders}
            onOrderSelect={onOrderSelect}
            category={category}
            voidOrder={voidOrder}
            copyOrder={copyOrder}
            toggleOrderForPayment={toggleOrderForPayment}
          />
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OrderTable;
